import React, { Component, useState, useEffect } from 'react'
import '../styles/AgroEnterpriseTracking.css'
import OrgFooter from '../widgets/OrgFooter'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'
import APIClusterRequest from '../api/APIClusterRequest'

class AgroEnterpriseTracking extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			isViewDetails: props.isViewDetails,
			stepTable: <StepOne />
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
		this.setContent = this.setContent.bind(this)
		this.setScrollable = this.setScrollable.bind(this)
	}

	onSubmit() {
	}

	componentWillMount() {
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('aet-scroll-area')
		const ca = document.getElementById('aet-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+54) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('.aet-cell2-input > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.setContent(e.target.id)
	}

	setContent(id) {
		let stepTable
		switch(id) {
			case "ae-step1":
				stepTable = <StepOne />
				break
			case "ae-step2":
				stepTable = <StepTwo />
				break
			case "ae-step3":
				stepTable = <StepThree />
				break
			case "ae-step4":
				stepTable = <StepFour />
				break
			case "ae-step5":
				stepTable = <StepFive />
				break
			case "ae-step6":
				stepTable = <StepSix />
				break
			case "ae-step7":
				stepTable = <StepSeven />
				break
			case "ae-step8":
				stepTable = <StepEight />
				break
			default:
				stepTable = <StepOne />
		}
		this.setState({stepTable: stepTable})
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="ae-tracking">
			<div id="aet-scroll-area"><div id="aet-client-area">
				<div className="title-bar">ACTIVE MEMBERS</div>
				<div id="aet-cell1">
					<div className="aet-cell1-input">
						<div>Step 1</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 2</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 3</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 4</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 5</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 6</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 7</div>
						<input type="number" value="100" disabled="true" />
					</div>
					<div className="aet-cell1-input">
						<div>Step 8</div>
						<input type="number" value="100" disabled="true" />
					</div>
				</div>
				<div className="title-bar">AE STEPS TRACKING</div>
				<div id="aet-cell2">
					<div id="aet-cell2-r1">
						<div className="aet-cell2-input">
							<div id="ae-step1" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 1</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step2" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 2</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step3" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 3</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step4" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 4</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step5" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 5</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step6" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 6</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step7" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 7</div>
						</div>
						<div className="aet-cell2-input">
							<div id="ae-step8" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
								onMouseLeave={this.mouseLeave}>STEP 8</div>
						</div>
					</div>
					<div id="aet-cell2-r2">
						<table className="aes-table-header">
							<col style={{width: '30%'}} />
							<col style={{width: '15%'}} />
							<col style={{width: '55%'}} />
							<tr>
								<th>AE Enterprise Key Outputs</th>
								<th>Date Achieved</th>
								<th>Comments</th>
							</tr>
						</table>
						{this.state.stepTable}
					</div>
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true}
				disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer"><OrgFooter submit={this.onSubmit} 
				showSubmit={true} disabled={this.state.isViewDetails} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

const StepOne = () => {
	const [foswg, setFOSWG] = useState()
	const [foc, setFOC] = useState()
	const [poc, setPOC] = useState()
	const [lrtp, setLRTP] = useState()


	const view = <div id="step-one">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>1.1 FORMATION OF SITE WORKING GROUP</td>
				<td>
					<DatePicker value={foswg} onChange={(value) => {
						this.setState({foSWP: value})
					}} />
				</td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>1.2 FORMATION OF CLUSTERS</td>
				<td>
					<DatePicker value={foc} onChange={(value) => {
						this.setState({foc: value})
					}} />
				</td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>1.3 PROFILING OF CLUSTERS</td>
				<td>
					<DatePicker value={poc} onChange={(value) => {
						this.setState({poc: value})
					}} />
				</td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>1.4 LOCAL RESEARCH TEAM PLANNING</td>
				<td>
					<DatePicker value={lrtp} onChange={(value) => {
						this.setState({lrtp: value})
					}} />
				</td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepTwo = () => {
	const view = <div id="step-two">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>2.1 SELECTION OF PRODUCT</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>2.2 PRODUCT MODULE FACILITATION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>2.3 PRELIMINARY CLUSTER SUPPLY PLANNING</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepThree = () => {
	const view = <div id="step-three">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>3.1 MARKET CHAIN STUDY ORIENTATION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>3.2 MARKET VISITS AND BUYERS INTERVIEW</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>3.3 MCS INFORMATION CONSOLODATION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>3.4 MCS REPORTING TO CLUSTER</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>3.5 DECISION OF TARGET BUYERS</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepFour = () => {
	const view = <div id="step-four">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>4.1 LRT PRESENTATION OF PSA AND MCS</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>4.2 CLUSTER MEMBER COMMITMENTS</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>4.3 CLUSTER POLICIES AND AGREEMENT</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>4.4 FORMAL ORGANIZATION OF CLUSTER</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepFive = () => {
	const view = <div id="step-five">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>5.1 AE PLAN - MARKET PLAN</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>5.2 AE PLAN - SUPPLY PLAN</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>5.3 AE PLAN - MANAGEMENT PLAN</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>5.4 AE PLAN - FINANCIAL PLAN</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>5.5 DECISION ON BUSINESS ACTION SCHEDULES</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepSix = () => {
	const view = <div id="step-six">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>6.1 ACTUAL AGRICULTURAL PRODUCTION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>6.2 CLUSTER SUPPLY PLAN REVIEW</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>6.3 CLUSTER PRODUCT SUPPLY FORECASTING</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>6.4 PLAN FINALIZATION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepSeven = () => {
	const view = <div id="step-seven">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>7.1 SUCCESSFUL NEGOTIATION WITH BUYER</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>7.2 TEST MARKETING PREPARTION</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>7.3 CONDUCT TEST MARKETING</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>7.4 POST-TEST MARKETING ASSESSMENT</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

const StepEight= () => {
	const view = <div id="step-eight">
		<table className="aes-table-data">
			<col style={{width: '30%'}} />
			<col style={{width: '15%'}} />
			<col style={{width: '55%'}} />
			<tr>
				<td>8.1 SWG PLANNING FOR STEPS 1-7</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
			<tr>
				<td>8.2 ADJUSTMENTS TO AE PLAN</td>
				<td><DatePicker /></td>
				<td><input type="text" className="step-comment" /></td>
			</tr>
		</table>
	</div>
	return(view)
}

export default AgroEnterpriseTracking
